import { render, staticRenderFns } from "./Form2_Empresa.vue?vue&type=template&id=4308c8ac"
import script from "./Form2_Empresa.vue?vue&type=script&lang=js"
export * from "./Form2_Empresa.vue?vue&type=script&lang=js"
import style0 from "./Form2_Empresa.vue?vue&type=style&index=0&id=4308c8ac&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4308c8ac')) {
      api.createRecord('4308c8ac', component.options)
    } else {
      api.reload('4308c8ac', component.options)
    }
    module.hot.accept("./Form2_Empresa.vue?vue&type=template&id=4308c8ac", function () {
      api.rerender('4308c8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/ES/Form2_Empresa.vue"
export default component.exports